<template>
    <div class="domain-search">
        <form method="get" action="https://my.cryo.host/cart.php">
            <div class="form-group search-container">
                <input type="hidden" name="a" value="checkDomain">
                <input type="text" name="domain" placeholder="Start by finding the perfect domain name">
                <div class="form-actions">
                    <button title="Clear input" class="clear-input" type="reset"><i class="fas fa-redo-alt fa-flip-horizontal"></i></button>
                    <button title="Search" class="search-domain" type="submit"><i class="fas fa-search"></i></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "DomainSearchComponent"
    }
</script>

<style lang="scss" scoped>
    .domain-search {
        .search-container {
            position: relative;

            .form-actions {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 420px;

                button {
                    color: white;
                    border-radius: 50%;
                    border: 0;
                    font-size: 15px;
                    padding: 4px;
                    height: 35px;
                    width: 35px;

                    &:focus {
                        outline: 0;
                    }
                }

                button[type="submit"] {
                    background: #3a7bd5;  /* fallback for old browsers */
                }

                button[type="reset"] {
                    margin-right: 3px;
                    background: #3a7bd5;  /* fallback for old browsers */
                    background: -webkit-linear-gradient(to right, #0e324d, #3a7bd5);  /* Chrome 10-25, Safari 5.1-6 */
                    background: linear-gradient(to right, #0e324d, #3a7bd5); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
                }
            }


            input {
                height: 50px;
                max-width: 500px;
                width: 100%;
                border: 0;
                border-radius: 30px;
                padding: 20px;
                box-shadow: 0px 1px 11px #e0e0e0;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;

                &:focus {
                    box-shadow: 0px 1px 11px #c5e0d2;
                    outline: 0;

                    &:after {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        border-radius: 5px;
                        border: 2px solid #ccc;
                    }
                }

            }
        }
    }

    @media screen and (max-width: 540px) {
        .domain-search {
            .search-container {
                .form-actions {
                    left: unset;
                    right: 10px;
                }
            }
        }
    }

    @media screen and (max-width: 400px) {
        .domain-search {
            .search-container {
                .form-actions {
                    .clear-input {
                        display: none;
                    }
                }
            }
        }
    }
</style>